import React from 'react';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const ProvinceOptions = () => {
    return (
        strings.provinces.map((province, i) => <option key={i} value={province.abbreviation}>{province.name}</option>)
    )
}

export default ProvinceOptions;


// WEBPACK FOOTER //
// ./src/components/Common/ProvinceOptions/ProvinceOptions.js